import { awardsApi } from 'api'
import { AwardsFile } from 'types/AwardsFile'

export const fetchFiles = (year: number = 2025) => awardsApi.get<AwardsFile[]>(`/files/${year}`)
